// extracted by mini-css-extract-plugin
export var container = "CopyButton-module--container--19518";
export var copiedNotification = "CopyButton-module--copiedNotification--f2f44";
export var up = "CopyButton-module--up--c8873";
export var visible = "CopyButton-module--visible--97c0c";